/** As verificações da georreferenciação de um modelo aberto: monta o
 *  conversor da projecção (o mesmo proj4 e a mesma definição do mapa) e
 *  chama as regras de verificacoesGeorref.ts. */

import { resolveProj4Def } from '@viewer/map/crsDefs'
import { loadProj4 } from '@viewer/map/proj4Lazy'
import type { Conversor } from './convergencia'
import type { LeituraDoMapa } from './leituraDoMapa'
import { verificarGeorref, type DadosDeGeorref, type ResultadoGeorref } from './verificacoesGeorref'

async function conversorDe(codigo: string | null | undefined): Promise<Conversor | null> {
  if (!codigo) return null
  try {
    const def = await resolveProj4Def(codigo)
    if (!def) return null
    const proj4 = await loadProj4()
    const c = proj4(def, 'WGS84')
    return {
      forward: (p) => c.forward(p) as [number, number],
      inverse: (p) => c.inverse(p) as [number, number],
    }
  } catch {
    return null
  }
}

export async function verificarGeorrefDoModelo(
  leitura: LeituraDoMapa | null,
  dados: DadosDeGeorref,
  distanciaGeometriaM: number | null,
): Promise<ResultadoGeorref> {
  const info = leitura?.crsInfo
  const conversor = info && !info.geografico && !info.naoSuportado ? await conversorDe(info.codigo) : null
  return verificarGeorref({ leitura, dados, conversor, distanciaGeometriaM })
}
